import { render, staticRenderFns } from "./DesktopLightBoxA.vue?vue&type=template&id=77bd06da&"
import script from "./DesktopLightBoxA.vue?vue&type=script&lang=js&"
export * from "./DesktopLightBoxA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports